<template>
  <div id="lsqk">
    <div v-for="item in list">

      <p><b>{{item.SJ.replace('-','月')}}日{{item.TITLE}}</b></p>
      <p>{{item.TEXT}}</p>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  export default {
    name: 'lsqk',
    data () {
      return {
        list: [{sj: '数据读取中'}]
      }
    },
    created: function () {
      ajax.getLsqk().then(
        data => {
          this.list = data
        }
      )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// lsqk.vue?55bd2274